const getPathSegments = (path) => {
  return path?.split('.')?.filter(Boolean) || [];
};

export default getPathSegments;
